import React, {useEffect, useLayoutEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setAccessToken} from "../slices/authSlice";
import {
    getLatestContentVersions,
    getContentVersionHistory
} from "../api/client";
import "./VisualVersionHistory.css";

import {Header} from "../components/Header";
import {setQueryString} from "../slices/usersSlice";
import {CenteredSpinner2} from "../components/CenteredSpinner";
import {HumanDate} from "../components/Helpers";
import {Badge, IconStatusHelp, Modal, Tooltip, Toggle} from "@seismic/mantle";
import {DebugPageModal, PageModalImage} from "./Lineage";
import {ClickAndDragScroll} from "../components/ClickAndDragScroll";

export const ShowPageModal = ({page, setPage}) => {

    const [display, setDisplay] = useState("Overlay");
    const showCurrentOnly = page?.previousPageThumbnailUrl == null;
    const showCurrent = display === "Current" || display === "Overlay";
    const showPrevious = display === "Previous" || display === "Overlay";
    
    useEffect(() => {
        setDisplay("Overlay");
    }, [JSON.stringify(page)]);

    return page == null ? null : <Modal
        size="lg"
        open={true}
        onClose={() => setPage(null)}
        header={display}
        closeOnOutsideClick
    >
        <div style={{width: "100%"}}>
            {!showCurrentOnly && <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: 8}}>
                <div></div>
                <div>
                    <span style={{paddingRight: 4}}>Select Display</span>
                    <select style={{width: 200}} value={display} onChange={(e)=>setDisplay(e.target.value)}>
                        <option value="Overlay">Overlay</option>
                        <option value="Current">Current</option>
                        <option value="Previous">Previous</option>
                    </select>
                </div>
            </div>}

            <div style={{display: "flex", alignItems: "center", justifyContent: "center", width: "100%"}}>
                <div className="image-container">
                    {(showCurrentOnly || showCurrent) && <img src={page.thumbnailUrl} alt={page.page} className="background-image" />}
                    {showPrevious && <img src={page.previousPageThumbnailUrl} alt={page.previousPage} className={showCurrent ? "overlay-image" : "background-image" }/>}
                </div>
            </div>
            <div style={{display: "flex", alignItems: "center", justifyContent: "center", width: "100%"}}>
                <Difference difference={page.difference} />    
            </div>
            {page?.difference != null && page.difference.extractedText1 != page.difference.extractedText2 &&  
                <>
                <div style={{display: "flex"}}>
                    <div style={{width: "50%"}}>
                        <h1>Previous Text</h1>
                        <div>
                            {page.difference.extractedText1}
                        </div>
                    </div>
                    <div style={{width: "50%"}}>
                        <h1>Current Text</h1>
                        <div>
                            {page.difference.extractedText2}
                        </div>
                    </div>
                </div>
                </>
            }
        </div>
    </Modal>
}

const Difference = ({difference}) => {
    
    if(difference == null)
        return null;
    
    var differenceColor = "green";
    if(difference.totalDifference > 20)
        differenceColor = "orange";
    if(difference.totalDifference > 40)
        differenceColor = "darkorange";
    if(difference.totalDifference > 50)
        differenceColor = "red";

    return <div>
        <span style={{color: differenceColor}}>{difference.totalDifference} differences</span>
        {difference.totalDifference > 0 && <>&nbsp;<Tooltip zIndex={10000} position="top" size="lg" variant="light" content={<small>
            {difference.differenceAverageHash > 0 && <div style={{whiteSpace: "nowrap"}}>Average Hash Distance: {difference.differenceAverageHash}</div>}
            {difference.differencePerceptualHash > 0 && <div style={{whiteSpace: "nowrap"}}>Perceptual Hash Distance: {difference.differencePerceptualHash}</div>}
            {difference.differenceDifferenceHash > 0 && <div style={{whiteSpace: "nowrap"}}>Difference Hash Distance: {difference.differenceDifferenceHash}</div>}
            {difference.differenceWaveletHash > 0 && <div style={{whiteSpace: "nowrap"}}>Wavelet Hash Distance: {difference.differenceWaveletHash}</div>}
            {difference.differenceColorHash > 0 && <div style={{whiteSpace: "nowrap"}}>Color Hash Distance: {difference.differenceColorHash}</div>}
            {difference.differenceSimHash > 0 && <div style={{whiteSpace: "nowrap"}}>Sim Hash Distance: {difference.differenceSimHash}</div>}
            {difference.differenceSimHash == null && <div style={{whiteSpace: "nowrap"}}>Sim Hash: Unavailable</div>}
        </small>}>
                    <span>
                        <IconStatusHelp size={16} />
                    </span>
        </Tooltip></>}
    </div>
}


const Page = ({index, pageId, previousPageId, page, smallMediumThumbnailUrl, difference, setPage, fullPage, debugMode}) => {
    
    if(index !== 0 && difference !== null && difference.totalDifference === 0)
        return <div id={pageId} style={{width: 200, height: 112, backgroundColor: "transparent", position: "relative", border: "1px solid transparent"}}>
            {debugMode && <div style={{padding: 4, position: "absolute", right: 0}}>{page}</div>}
        </div>
    
    return <div id={pageId} style={{width: 200, height: 112, backgroundColor: "#f3f4f6", position: "relative", border: index > 0 && previousPageId == null ? "1px solid blue" : "1px solid #868e96"}}>
        {index > 0 && previousPageId == null && <div style={{padding: 4, position: "absolute"}}> <Badge style={{border: "1px solid black"}} count={"new"} variant="primary" /></div>}
        {debugMode && <div style={{padding: 4, position: "absolute", right: 0}}>{page}</div>}
        {(false || (difference === null || difference.totalDifference > 0)) && <img onClick={()=>setPage(fullPage)} style={{border: "1px solid #cfd4da", objectFit: "scale-down", width: 200, height: 110}} alt={page} loading="lazy" src={smallMediumThumbnailUrl} />}
    </div>
}

const Version = ({debugMode, index, contentVersionId, teamsiteId, contentId, name, format, type, createdAt, isDeleted, isPublished, version, createdBy, createdByEmail, pages, setDebugPage, setPage}) => {
    return <div style={{padding: 16, zIndex: -10000, display: "table-cell", borderRight: "1px dashed gray"}}>
        <div style={{display: "flex", justifyContent: "center"}}>
            <div><a href={`mailto:${createdByEmail}`}>{createdBy}</a></div>
        </div>
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", alignContent: "center"}}>
            <div><a target="_blank" href={`https://quake.seismic.com/app#/contentmanager/detail/${teamsiteId}/${contentId}/info/LIST/title?versionId=${contentVersionId}&structureId=undefined`}>v{version}</a></div>
            <div><HumanDate date={createdAt} /></div>
        </div>
        {debugMode && <>
        <hr />
        <div>
            <div><a onClick={()=>setDebugPage({contentVersionId, name})}>Debug</a></div>
            <div>{contentVersionId}</div>
        </div>
        </>}
        <hr />
        <div id={contentVersionId} style={{display: "flex", flexDirection: "column", gap: 8, alignItems: "center", alignContent: "center"}}>
            {pages.map(a=><Page debugMode={debugMode} key={a.pageId} index={index} setPage={setPage} {...a} fullPage={a} />)}
        </div>
    </div>
}

export const VisualVersionHistory = () => {

    const urlParams = new URLSearchParams(window.location.search);
    const qsContentId = urlParams.get('contentVersionId');
    const dispatch = useDispatch();
    const [contentList, setContentList] = useState([]);
    const [selectedContentId, setSelectedContentId] = useState(null);
    const [content, setContent] = useState(null);
    const [page, setPage] = useState(null)
    const [debugPage, setDebugPage] = useState(null);
    const [debugMode, setDebugMode] = useState(false);
    
    useEffect(() => {
        getLatestContentVersions()
            .then(data => {
                setContentList(data);
                if(data.filter(a=>a.id === qsContentId).length > 0)
                    setSelectedContentId(qsContentId);
                else
                    setSelectedContentId(data[0].id);
            })
    }, []);

    useEffect(() => {
        if (selectedContentId === null)
            return;
        setContent(null);
        getContentVersionHistory(selectedContentId)
            .then(data => {
                setContent(data)
            })
    }, [selectedContentId]);
    
    const signOut = () => {
        dispatch(setAccessToken(null));
    }

    const getStrokeStyle = (difference) => {
        if(difference === 0)
            return "green";
        if(difference <= 15)
            return "lime";
        if(difference <= 30)
            return "butter";
        if(difference <= 40)
            return "orange";
        if(difference <= 50)
            return "red";
        return "darkred";
    }

    const drawText = (ctx, txt, font, x, y) => {

        /// lets save current state as we make a lot of changes        
        ctx.save();

        /// set font
        ctx.font = font;

        /// draw text from top - makes life easier at the moment
        ctx.textBaseline = 'top';

        /// color for background
        ctx.fillStyle = getStrokeStyle(txt);

        /// get width of text
        var width = ctx.measureText(txt).width + 10;

        /// draw background rect assuming height of font
        ctx.fillRect(x, y, width, parseInt(font, 10) + 5);

        /// text color
        ctx.fillStyle = '#fff';

        /// draw text on top
        ctx.fillText(txt, x + 5, y);

        /// restore original state
        ctx.restore();
    }
    const drawCircle= (ctx, x, y, radius, fill, stroke, strokeWidth, text)  => {
        ctx.beginPath()
        ctx.arc(x, y, radius, 0, 2 * Math.PI, false)
        ctx.fillText(text, x, y);
        if (fill) {
            ctx.fillStyle = fill
            ctx.fill()
        }
        if (stroke) {
            ctx.lineWidth = strokeWidth
            ctx.strokeStyle = stroke
            ctx.stroke()
        }
    }
    
    const draw = () => {

        if (content == null)
            return;
        
        console.log("draw")
        
        const canvas = document.getElementById('connecting-lines');
        const ctx = canvas.getContext('2d');

        //const container = document.getElementById('container');
        //container.width = canvas.parentElement.scrollWidth; //doesn't seem to do what I want :(
        //container.minWidth = canvas.parentElement.scrollWidth; //doesn't seem to do what I want :(
        //container.maxWidth = canvas.parentElement.scrollWidth; //doesn't seem to do what I want :(
        
        canvas.width = canvas.parentElement.scrollWidth;
        canvas.height = canvas.parentElement.scrollHeight;
        
        ctx.fillStyle = "transparent";
        //ctx.fillStyle = "pink";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        //ctx.font = "30px Arial";
        //ctx.fillStyle = "black";
        //ctx.fillText(`w${canvas.width} x h${canvas.height}`, 10, 50);
        //ctx.fillText(`w${canvas.parentElement.clientWidth} x h${canvas.parentElement.clientHeight}`, 10, 100);

        let extraHeight = canvas.parentElement.getBoundingClientRect().y;

        for(let i = 0; i < content.length; i++) {
            let version = content[i];
            for(let j = 0; j < version.pages.length; j++) {
                let page = version.pages[j];
                if(page.previousPageId !== null) {
                    let previous = document.getElementById(page.previousPageId);
                    let current = document.getElementById(page.pageId);
                    const start = previous.getBoundingClientRect();
                    const end = current.getBoundingClientRect();
                    //console.log("previous", previous, start)
                    //console.log("current", current, end)
                    
                    const color = getStrokeStyle(page.difference.totalDifference);
                    
                    ctx.beginPath();
                    ctx.lineWidth = 2;
                    ctx.strokeStyle = color;
                    
                    let startX = start.right - 16;
                    let startY = (start.top + start.height / 2) - extraHeight;
                    let endX = end.left - 16;
                    let endY = (end.top + end.height / 2) - extraHeight;
                    
                    ctx.moveTo(startX, startY);
                    ctx.lineTo(endX, endY);
                    ctx.stroke();

                    //behind image
                    let behindImageLeft = end.left - 16;
                    let behindImageRight = end.right - 16;
                    ctx.moveTo(behindImageLeft, endY);
                    ctx.lineTo(behindImageRight, endY);
                    ctx.stroke();
                    
                    if(page.nextPageId == null){
                        let lastX = end.right - 16;
                        ctx.moveTo(lastX, endY + 8);
                        ctx.lineTo(lastX, endY - 8);
                        ctx.stroke();
                    }

                    if(false) {
                        if (page.difference.totalDifference != 0 || page.difference.differenceSimHash != 0) {
                            drawText(ctx, page.difference.totalDifference, "12pt verdana", startX, startY);
                            drawText(ctx, page.difference.differenceSimHash, "12pt verdana", startX, startY + 25);
                        }
                    }
                }
            }
        }
    }
    
    useEffect(() => {
        let timer1 = setTimeout(() => draw(), 1000)
        function handleResize() {
            draw();
        }
        window.addEventListener('resize', handleResize)
        return _ => {
            window.removeEventListener('resize', handleResize)
            clearTimeout(timer1)
        }
    }, [content])
    
    return <div style={{display: "flex", flexDirection: "column", height: "100vh", width: "100%"}}>
        <Header signOut={signOut} title="Visual Version History" navigateTo="/VisualVersionHistory" />
        <div style={{padding: "16px", display: "flex", flexDirection: "column", flex: 1}}>
            <div style={{paddingBottom: 16, display: "flex", alignItems: "center", gap: 8, justifyContent: "space-between"}}>
                <div>
                    <select value={selectedContentId} onChange={(e) => {
                        setQueryString("contentVersionId", e.target.value);
                        setSelectedContentId(e.target.value)
                    }
                    }>
                        {contentList.map(item => (
                            <option key={item.id} value={item.id}>
                                {item.name} ({item.total} versions)
                            </option>
                        ))}
                    </select>
                </div>
                <div>
                    <span style={{paddingRight: 8}}>Debug Mode</span>
                    <Toggle checked={debugMode} onChange={(e)=>{setDebugMode(e.target.checked);setTimeout(() => draw(), 150)();}} />
                </div>
            </div>
            <div style={{display: "flex", flex: 1, maxHeight: "100%", flexShrink: 1, flexGrow: 1, flexBasis: 1, overflow: "auto", border: "1px solid #cfd4da", borderRadius: 4}}>
                {content === null && <CenteredSpinner2 />}
                {content && <>
                    <ClickAndDragScroll>
                        <div id="container" style={{width: content.length * 233}}> {/* this width hack isn't production quality */}
                            <canvas id="connecting-lines"></canvas>
                            <DebugPageModal debugPage={debugPage} setDebugPage={setDebugPage} />
                            <ShowPageModal page={page} setPage={setPage} />
                            {content.map((a, b)=><Version debugMode={debugMode} index={b} key={a.content} {...a} setDebugPage={setDebugPage} setPage={setPage} />)}
                        </div>
                    </ClickAndDragScroll>
                </>}
            </div>

        </div>
    </div>;
}